import * as React from 'react';
import { TranslateFunction } from 'react-localize-redux';
import * as Api from '../../Api';
const tinycolor = require('tinycolor2');

interface TipOptionButtonProps {
  designScheme: Api.AppDesignScheme;
  children: number;
  active: boolean;
  translate: TranslateFunction;
  onChange(percentage: number);
}

const TipOptionButton = (props: TipOptionButtonProps) => {
  const { children, translate, active, designScheme } = props;

  const [hovering, setHovering] = React.useState(false);

  const onChange = () => {
    props.onChange(props.children);
  };

  const onHoverTipOption = () => {
    setHovering(true);
  };

  const onLeaveTipOption = () => {
    setHovering(false);
  };

  const buttonStyle = React.useMemo(() => {
    if (active || hovering) {
      return { backgroundColor: designScheme.Secondary, color: 'white' };
    }

    return {
      backgroundColor: tinycolor(designScheme.Secondary)
        .lighten(15)
        .toString(),
      color: designScheme.Primary
    };
  }, [active, hovering, designScheme]);

  return (
    <button
      aria-label={`${translate('Set_tip_to')} ${children}%`}
      className="fd-button fd-button--big tip-button flex flex-align-center flex-justify-center flex-one"
      key={`tip-button-${children}`}
      onMouseEnter={onHoverTipOption}
      onMouseLeave={onLeaveTipOption}
      style={buttonStyle}
      onClick={onChange}
    >
      <p className="clear-margins percentage-text">{children}%</p>
    </button>
  );
};

interface Props {
  tipPercentageOptions: number[];
  selectedTipPercentage: number;
  designScheme: Api.AppDesignScheme;
  translate: TranslateFunction;
  onChange(percentage: number);
}

const TipOptions = (props: Props) => {
  const {
    tipPercentageOptions,
    selectedTipPercentage,
    designScheme,
    translate,
    onChange
  } = props;

  return (
    <div className="tip-options-container">
      <div className="flex checkout__options">
        {tipPercentageOptions.map(tip => (
          <TipOptionButton
            key={`${tip}`}
            translate={translate}
            designScheme={designScheme}
            active={selectedTipPercentage === tip}
            onChange={onChange}
          >
            {tip}
          </TipOptionButton>
        ))}
      </div>
    </div>
  );
};

export default React.memo(TipOptions);
